import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { SidebarToggle } from './SidebarToggle';
export var CollapsedSidebar = function (_a) {
    var onStartFloating = _a.onStartFloating, onExpand = _a.onExpand;
    var navElement = useRef(null);
    return (_jsxs("nav", { className: "CollapsedSidebar", ref: navElement, children: [_jsx("button", { title: "show-sidebar", onMouseEnter: onStartFloating, onClick: onStartFloating, className: "CollapsedSidebar-button", children: _jsx("div", { className: "CollapsedSidebar-handle" }) }), _jsx(SidebarToggle, { expand: true, variant: "tab", accented: true, shadow: true, onExpand: onExpand })] }));
};
